module.exports = __webpack_public_path__ + "img/icon-remove-hand-02.b3013ce2.svg";